import script from "./BottomButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./BottomButton.vue?vue&type=script&setup=true&lang=ts"

import "./BottomButton.vue?vue&type=style&index=0&id=f114fa56&scoped=true&lang=scss"

import exportComponent from "/drone/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f114fa56"]])

export default __exports__